module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bNewi"))).then(() => module.bundle.root('dsisd'));